// 国企模块分享（轻量 mixin，不含微信授权逻辑）
// 分享链接固定为当前路由：origin + pathname + #/当前路径?当前 query + 来源参数
// 页面可在 data 中定义 shareTitle / shareDesc 覆盖默认值，默认标题取路由 meta.title
const SHARE_LOGO = 'http://dm.zhongpukeji.cn/f/image/1788155228915.png'

export default {
  created () {
    this.guoqiShare()
  },
  methods: {
    // 拼装当前路由的分享链接
    guoqiShareUrl () {
      const query = Object.assign({}, this.$route.query, {
        fromOpenId: this.$cookies.get('openId'),
        ladingPageId: localStorage.getItem('ladingPageId'),
        tenantId: localStorage.getItem('tenantId')
      })
      const search = Object.keys(query)
        .filter((k) => query[k] !== undefined && query[k] !== null && query[k] !== '')
        .map((k) => `${k}=${encodeURIComponent(query[k])}`)
        .join('&')
      return window.location.origin + window.location.pathname + '#' + this.$route.path + (search ? `?${search}` : '')
    },
    guoqiShare () {
      this.$api
        .get('/api/wechat/share/get', {
          url: window.location.href.split('#')[0]
        })
        .then((res) => {
          const that = this
          wx.config({
            debug: false, // 开启调试模式，可 alert 返回值和报错
            appId: res.result.appId,
            timestamp: res.result.timestamp,
            nonceStr: res.result.nonceStr,
            signature: res.result.signature,
            jsApiList: [
              'checkJsApi',
              'onMenuShareTimeline',
              'onMenuShareAppMessage',
              'updateTimelineShareData',
              'updateAppMessageShareData'
            ]
          })
          wx.ready(function () {
            const link = that.guoqiShareUrl()
            const title = that.shareTitle || (that.$route.meta && that.$route.meta.title) || '国企供应链贸易'
            const desc = that.shareDesc || ''
            const imgUrl = that.shareLogo || SHARE_LOGO
            wx.onMenuShareAppMessage({ title, desc, link, imgUrl })
            wx.onMenuShareTimeline({ title, desc, link, imgUrl })
            wx.updateTimelineShareData({ title, desc, link, imgUrl })
            wx.updateAppMessageShareData({ title, desc, link, imgUrl })
          })
          wx.error(function (res) {
            console.log('打印错误消息:', res.errMsg) // debug 时可用
          })
        })
    }
  }
}
